<template>
  <span class="cursor-pointer" :class="{'btn btn-secondary': type == 'secondary'}" @click="openGuide()">
    <font-awesome-icon v-if="icon && icon.length" :icon="icon"/>
    <font-awesome-icon v-else icon="info-circle"/>
    <span v-if="text && text.length">
      {{ text }}
    </span>
    <span v-if="!text">
      {{ $t('system.help_center_label') }}
    </span>
  </span>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'GuideButton',
    data: function() {
      return {
        error: '',
        showCheckbox: false,
        doNotShowGuide: 0,
        wpGuide: {}
      }
    },
    props: {
      guide: {},
      text: {},
      type: {},
      icon: {},
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
    },
    watch: {

    },
    methods: {
      openGuide() {

        // Get the current language from local storage
        let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

        // Open guide if there is external link (with selected language)
        if (this.guide && this.guide.external_id) {
          window.open('https://complyon.com/' + language + '/?p=' + this.guide.external_id, '_blank')
        }
      }
    },
    created () {
      let self = this;
    }
  }
</script>
